export default "__VITE_ASSET__Bc88FC42__"